import { MilestonesRequest } from "../api/MilestonesRequest"
import { FetchMilestonesResponse } from "../interfaces/question";


export const getMilestonesQuestions = async (payload: any): Promise<FetchMilestonesResponse> => {
    return new Promise(async(resolve:any, reject: any) => {
        try{
            const resp = await MilestonesRequest.post('/fetch_milestones/', payload);
            resolve(resp.data);
        } catch(err){
            reject(err)
        }
    })
}

export const answersBulkSave = (payload: any) => {
    return new Promise(async(resolve:any, reject: any) => {
        try{
            await MilestonesRequest.post('/api/0.1/answers/bulk_save/', payload)
            resolve(true);
        } catch(err){
            reject(err);
        }
    })
}


export const getMilestonesToEdit = (url: string) => {
    return new Promise(async(resolve:any, reject:any) => {
        try{
            const resp = await MilestonesRequest.get(url);
            resolve(resp.data);
        } catch(err){
            reject(err)
        }
    })
}
